// `save` — the batch save; shown only when it was refused (the problems, each
// with a "Go to step", are listed above). Warnings and reason-for-change are
// the shared modals and never land here.

import AutoStep from './AutoStep'
import type { StepProps } from './common'

export default function SaveStep(props: StepProps) {
  return <AutoStep {...props} retryLabel="Save again" note="Nothing was saved. Fix what is listed and save again." />
}
